import {
    Country,
    SuperbetRouteConfig,
} from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import { AnalyticsScreenNames } from '@app/utils/analyticsScreenNames';
import WikiPage from '@pages/WikiPage.vue';
import { omit as _omit } from 'lodash';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getConfig } from '@superbet-group/web.lib.config';

export const wikiRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.App.Wiki,
        name: RouteName.App.Wiki,
        components: {
            ...(shellLocalConfig.hasTicketsOutsideSportsProduct
                ? defaultLayout
                : _omit(defaultLayout, ['tickets'])
            ),
            content: WikiPage,
        },
        meta: {
            title: Title.App.Wiki,
            superAnalytics: {
                pageName: AnalyticsScreenNames.wiki,
            },
        },
    },
];

if (getConfig().countrySpecific.country === Country.Br) {
    wikiRoutes.push({
        path: '/wiki/:pageSlug',
        redirect: { name: RouteName.App.Wiki },
    });
}
